import Controller from 'controllers/controller';
import Elements from 'tools/elements';
import Binder from 'tools/binder';

class PeopleController extends Controller {
    constructor(app) {
        super(app);
        
        this.elements = new Elements;
        this.binder = new Binder(this);
        
        console.log('people construct');
        
        this.app.on('people-loaded', () => {
            this.cacheElements();
            this.attachEvents();
        })
    }
    
    cacheElements() {
        this.elements.queryOne('page', '.page[data-template="people"]');
        this.elements.queryAll('people', '.person .image', 'page');
    }

    attachEvents() {
        console.log('attach events');
        this.elements.each('people', person => {
            person.addEventListener('click', this.binder.bind('onPersonClick'));
        });
    }

    onPersonClick(event) {
        let person = event.currentTarget;
        
        console.log(person);
        
        person.classList.add('force-hover');
        
        setTimeout(() => {
            person.classList.remove('force-hover');
        }, 1000);
    }
}

export default PeopleController;